import { Component, computed, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Card } from '@openng/optimus-ui/card';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@openng/optimus-ui/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import {
    ServicePaymentFormComponent,
} from '../../../../components/services/service-payment/services-payments-detail-page/service-payment-form.component';
import {
    ServicePaymentMedicalProceduresComponent,
} from '../../../../components/services/service-payment/service-payment-medical-procedures/service-payment-medical-procedures.component';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { ServicesPaymentsDetailPageStore } from './services-payments-detail-page.store';
import { serviceExpertiseAllowed } from '@libs/types/src/services/enum/service-type.enum';
import {
    ServicePaymentPuroComponent,
} from '../../../../../../components/medical-service/setting/service-payment-puro/service-payment-puro.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { featureOn } from '../../../../../../feature-flag';
import {
    ServicePaymentPmupComponent,
} from '../../../../../../components/medical-service/setting/service-payment-pmup/service-payment-pmup.component';

@Component({
    selector: 'app-services-payments-detail-page',
    templateUrl: './services-payments-detail-page.component.html',
    styleUrl: './services-payments-detail-page.component.scss',
    imports: [
        Card,
        Tabs,
        TabList,
        Tab,
        TranslatePipe,
        TabPanels,
        TabPanel,
        ServicePaymentFormComponent,
        ServicePaymentMedicalProceduresComponent,
        ServicePaymentPuroComponent,
        ServicePaymentPmupComponent,
    ],
    providers: [
        ServicesPaymentsDetailPageStore,
    ],
})
export class ServicesPaymentsDetailPageComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);


    protected readonly store = inject(ServicesPaymentsDetailPageStore);

    updateId = 0;
    copyId = 0;

    protected puroForm = fb.group({
        payment: fb.control(0, { nonNullable: true }),
        highCostPayment: fb.control(0, { nonNullable: true }),
        clients: fb.control(0, { nonNullable: true }),
        puroRef: fb.control(0, { nonNullable: true }),
        direct: fb.control<boolean>(false, { nonNullable: true }),
        coefficients: fb.control<string[]>([], { nonNullable: true }),
    });

    protected pmupForm = fb.group({
        payment: fb.control(0, { nonNullable: true }),
        pumRef: fb.control(0, { nonNullable: true }),
        pmupRef: fb.control(0, { nonNullable: true }),
        direct: fb.control<boolean>(false, { nonNullable: true }),
    });
    protected puroFormChange = toSignal(this.puroForm.valueChanges);
    protected pmupFormChange = toSignal(this.pmupForm.valueChanges);

    protected serviceId = computed(() => Number(routeParams.serviceId()));
    protected serviceExpertise = computed(() =>
        this.store.globalGlobalStore.organizationStore.getServiceBySignalId(this.serviceId)()?.expertise?.code || '',
    );
    protected usePURO = computed(() =>
        serviceExpertiseAllowed.puro.includes(this.serviceExpertise()) && featureOn.PURO,
    );
    protected usePMUP = computed(() =>
        serviceExpertiseAllowed.pmup.includes(this.serviceExpertise()) && featureOn.PURO,
    );

    ngOnInit() {
        this.updateId = Number(this.route.snapshot.paramMap.get('paymentId') ?? 0);
        this.copyId = Number(history.state['copyId'] ?? 0);
    }

}
